module.exports = __webpack_public_path__ + "img/4.702e8eab.png";